import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Stethoscope, LogOut, LayoutDashboard } from 'lucide-react';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isClinicPortal = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/login');

  if (isClinicPortal && user) {
    return (
      <nav className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/clinic/dashboard" className="flex items-center space-x-2">
              <Stethoscope className="h-8 w-8 text-blue-600" />
              <span className="font-bold text-xl text-slate-900">TapPet</span>
            </Link>
            
            <div className="flex items-center space-x-4">
              <Link to="/clinic/dashboard">
                <Button variant="ghost" className="flex items-center space-x-2">
                  <LayoutDashboard className="h-4 w-4" />
                  <span>Dashboard</span>
                </Button>
              </Link>
              <div className="text-sm text-slate-600">{user.email}</div>
              <Button
                onClick={handleLogout}
                variant="outline"
                className="flex items-center space-x-2"
                data-testid="logout-button"
              >
                <LogOut className="h-4 w-4" />
                <span>Salir</span>
              </Button>
            </div>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <Stethoscope className="h-8 w-8 text-blue-600" />
            <span className="font-bold text-xl text-slate-900">TapPet</span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-slate-700 hover:text-blue-600 transition-colors">Inicio</Link>
            <Link to="/how-it-works" className="text-slate-700 hover:text-blue-600 transition-colors">Cómo Funciona</Link>
            <Link to="/pricing" className="text-slate-700 hover:text-blue-600 transition-colors">Precios</Link>
            <Link to="/contact" className="text-slate-700 hover:text-blue-600 transition-colors">Contacto</Link>
            <Link to="/owner/login">
              <Button variant="outline" className="border-blue-600 text-blue-600 hover:bg-blue-50">
                Portal Dueño
              </Button>
            </Link>
            <Link to="/clinic/login">
              <Button className="bg-blue-600 hover:bg-blue-700" data-testid="login-button">
                Acceso Clínica
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
